import { render, staticRenderFns } from "./SiteSearchClose.vue?vue&type=template&id=8acfee4e&"
import script from "./SiteSearchClose.vue?vue&type=script&lang=ts&"
export * from "./SiteSearchClose.vue?vue&type=script&lang=ts&"
import style0 from "./SiteSearchClose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonCircle: require('/tmp/build_453bf6d7/src/components/button/Circle.vue').default,Button: require('/tmp/build_453bf6d7/src/components/button/Button.vue').default})
